import { formatCurrency } from '@on3/ui-lib/utils/formatters';
import { On3Avatar } from 'components/Image/On3Avatar';
import { getNILProfileLink } from 'components/Nil/helpers';
import { TextLink } from 'components/UI/Link/TextLink';
import { StarRating } from 'components/UI/StarRating/StarRating';
import { Text } from 'components/UI/Typography/Text';

import { CompactHeaderProps as ICompactHeaderProps } from './CompactHeader';
import styles from './CompactHeader.module.scss';

export const CompactPlayer = ({ basicInfo }: ICompactHeaderProps) => {
  const nilValue = basicInfo?.nilValue ? (
    <span className={styles.playerSpecData}>
      {formatCurrency(basicInfo?.nilValue)}
    </span>
  ) : (
    <span className={styles.valuationUndisclosed}>undisclosed</span>
  );

  const profileLink = getNILProfileLink({
    sport: basicInfo?.defaultSport?.name,
    slug: basicInfo?.slug,
  });

  return (
    <div className={styles.measurementWrapper}>
      <On3Avatar
        altText={basicInfo?.defaultAsset?.altText || 'Player Avatar'}
        className={styles.avatar}
        {...basicInfo?.defaultAsset}
        fit="cover"
        height={60}
        quality={90}
        radiusFive
        width={60}
      />
      <div className={styles.playerSpecsContainer}>
        <div className={styles.playerSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            Class Year
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {basicInfo?.classYear || '-'}
          </Text>
        </div>
        <div className={styles.playerSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            info
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {basicInfo?.positionAbbreviation || '-'} /{' '}
            {basicInfo?.height || '-'} / {basicInfo?.weight || '-'}
          </Text>
        </div>
        <div className={styles.playerSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            Industry Ranking
          </Text>
          <StarRating
            className={styles.playerSpecData}
            fiveStarPlus={basicInfo?.ranking?.fiveStarPlus}
            href={`/db/${basicInfo?.slug}/industry-comparison/`}
            isConsensus
            rating={basicInfo?.ranking?.rating}
            sport={basicInfo?.defaultSport?.name}
            stars={basicInfo?.ranking?.stars}
            year={basicInfo?.classYear?.toString()}
          />
        </div>
        <div className={styles.playerSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            nil value
          </Text>
          <TextLink href={profileLink} underline="none" variant="subtitle1">
            {nilValue}
          </TextLink>
        </div>
        <div className={styles.playerSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            high school
          </Text>

          <Text className={styles.playerSpecData} variant="subtitle1">
            <TextLink href={`/high-school/${basicInfo?.highSchool?.urlSlug}/`}>
              {basicInfo?.highSchool?.name}
            </TextLink>
          </Text>
        </div>
        <div className={styles.playerSpec}>
          <Text className={styles.playerSpecLabel} variant="subtitle1">
            hometown
          </Text>
          <Text className={styles.playerSpecData} variant="subtitle1">
            {basicInfo?.hometownName}
          </Text>
        </div>
      </div>
    </div>
  );
};
